<template>
  <div ref="container3d" class="position-relative w-100 h-100"></div>
</template>
<script>
import * as Three from "three"
import {FBXLoader} from "three/examples/jsm/loaders/FBXLoader"
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls"
import {CSS2DObject, CSS2DRenderer} from "three/examples/jsm/renderers/CSS2DRenderer.js"

export default {
  name: "fbxViewer",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      default: "",
    },
    srcTexture: {
      type: String,
      default: "",
    },
    srcTextures: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      vloading: true,
      modelopen: false,
      modelsrc: "",
      modelSrcTexture: "",
      // трехмерный three.js
      camera: null,
      scene: null,
      renderer: null,
      labelRenderer: null,
      mesh: null,
      light: null,
      mixer: null,
      controls: null,
      length: 200,
      fullscreen: false,

      pointsArray: [],
      window_mouse: true,

      mouseclick: false,
      measurebool: false,
      measuretype: 0,
      objects: [],
      points: [],
      modelmesh: null,
      particleMaterial: null,

      leftmousecdownlocation: null,

      // Кэшировать всю информацию об измерениях
      allpointarr: [],
      alllinearr: [],
      alltextarr: [],
      modelSrcTextures: [],
    }
  },
  watch: {
    open: {
      handler: function (e) {
        this.modelopen = e
      },
    },
    modelopen: {
      handler: function (e) {
        if (e === false) {
          this.$emit("modelopen", false)
          this.vloading = true
          this.$refs.container3d.innerHTML = ""
          this.measurebool = false
          this.allpointarr = []
          this.alllinearr = []
          this.alltextarr = []
          this.points = []
          this.pointsArray = []
          document.getElementById("chiziicon").style.color = ""
          document.getElementById("zhixian").style.opacity = "0"
          document.getElementById("quxian").style.opacity = "0"
          for (let index = 0; index < this.allpointarr.length; index++) {
            this.scene.remove(this.allpointarr[index])
          }
          for (let index = 0; index < this.alllinearr.length; index++) {
            this.scene.remove(this.alllinearr[index])
          }
          for (let index = 0; index < this.alltextarr.length; index++) {
            this.scene.remove(this.alltextarr[index])
          }
        }
      },
    },
    src: {
      handler: function (e) {
        this.modelsrc = e
      },
    },
  },
  mounted() {
    this.modelsrc = this.src
    this.modelSrcTexture = this.srcTexture
    if (this.srcTextures) this.modelSrcTextures = this.srcTextures
    this.init3d()
  },

  methods: {
    // трехмерный three.js
    init3d: function () {
      let container = this.$refs.container3d

      this.vloading = true

      this.scene = new Three.Scene()
      this.scene.background = new Three.Color(0x6c757d)

      this.light = new Three.HemisphereLight(0xffffff, 0x444444)
      this.light.position.set(0, 200, 0)
      this.scene.add(this.light)

      this.light = new Three.DirectionalLight(0xffffff)
      this.light.position.set(0, 10, 10)
      this.light.castShadow = true
      this.light.shadow.camera.top = 180
      this.light.shadow.camera.bottom = -100
      this.light.shadow.camera.left = -120
      this.light.shadow.camera.right = 120
      this.scene.add(this.light)

      this.light = new Three.DirectionalLight(0xffffff)
      this.light.position.set(0, 10, -10)
      this.light.castShadow = true
      this.scene.add(this.light)

      var PI2 = Math.PI * 2
      this.particleMaterial = new Three.SpriteMaterial({
        color: 0xff0000,
        // map: new Three.Texture(this.modelSrcTexture),
        // program: function (context) {
        //   context.beginPath()
        //   context.arc(0, 0, 0.5, 0, PI2, true)
        //   context.fill()
        // },
      })
      var loader = new FBXLoader()
      // modelsrc - это путь к модели
      loader.load(this.modelsrc, (geometry) => {
        const loaderTexture = new Three.TextureLoader()

        if (this.modelSrcTextures[0]) {
          geometry.traverse((child) => {
            if (child instanceof Three.Mesh) {
              // apply texture
              if (this.modelSrcTextures[0]) child.material.map = loaderTexture.load(this.modelSrcTextures[0])
              if (this.modelSrcTextures[1]) child.material.specularMap = loaderTexture.load(this.modelSrcTextures[1])
              if (this.modelSrcTextures[2]) child.material.normalMap = loaderTexture.load(this.modelSrcTextures[2])
              child.material.needsUpdate = true
              child.castShadow = true
              child.receiveShadow = true
              child.flatShading = true
            }
          })
        } else if (this.modelSrcTexture !== "") {
          geometry.traverse((child) => {
            if (child instanceof Three.Mesh) {
              // apply texture
              child.material.map = loaderTexture.load(this.modelSrcTexture)
              child.material.needsUpdate = true
            }
          })
        }

        this.scene.add(geometry)
        this.modelmesh = geometry

        // Камера инициализируется размером модели
        var boxHelper = new Three.BoxHelper()
        this.camera = new Three.PerspectiveCamera(70, container.clientWidth / container.clientHeight, 1, 10000)
        boxHelper.setFromObject(geometry)
        var center = boxHelper.geometry.boundingSphere.center
        var radius = boxHelper.geometry.boundingSphere.radius
        var cameraPos = new Three.Vector3(
          center.x + geometry.position.x,
          radius * 0.8 + center.y + geometry.position.y,
          radius * 1.5 + center.z + geometry.position.z,
        )
        var lookPos = new Three.Vector3(
          center.x + geometry.position.x,
          center.y + geometry.position.y,
          center.z + geometry.position.z,
        )
        this.camera.position.copy(cameraPos)

        this.renderer = new Three.WebGLRenderer({antialias: true})

        this.renderer.setSize(container.clientWidth, container.clientHeight)

        container.appendChild(this.renderer.domElement)

        // рендеринг метки
        this.labelRenderer = new CSS2DRenderer()
        this.labelRenderer.setSize(container.clientWidth, container.clientHeight)
        this.labelRenderer.domElement.style.position = "absolute"
        this.labelRenderer.domElement.style.top = "0px"
        container.appendChild(this.labelRenderer.domElement)

        window.addEventListener("resize", this.onWindowResize(), false)
        this.controls = new OrbitControls(this.camera, this.labelRenderer.domElement)
        this.controls.target = lookPos
        this.camera.lookAt(lookPos)

        // Инициализируем сначала, если режим измерения включен при переключении на полноэкранный режим
        if (this.measurebool === true) {
          for (let index = 0; index < this.allpointarr.length; index++) {
            this.scene.add(this.allpointarr[index])
          }
          for (let index = 0; index < this.alllinearr.length; index++) {
            this.scene.add(this.alllinearr[index])
          }
          for (let index = 0; index < this.alltextarr.length; index++) {
            this.scene.add(this.alltextarr[index])
          }
        }
        var _this = this
        setTimeout(function () {
          _this.animate3d()
          _this.vloading = false
        }, 1000)
      })
    },
    animate3d: function () {
      requestAnimationFrame(this.animate3d)
      this.renderer.render(this.scene, this.camera)
      this.labelRenderer.render(this.scene, this.camera)
      this.controls.update()
    },
    onWindowResize() {
      let container = this.$refs.container3d
      this.camera.aspect = container.clientWidth / container.clientHeight
      this.camera.updateProjectionMatrix()

      this.renderer.setSize(container.clientWidth, container.clientHeight)
    },
  },
}
</script>
